import { action } from 'lib/actionHelpers';
import { putMessageStatus } from 'redux/actions/leadModalActions';
import { publishAction } from 'redux/actions/messagesActions';
import normalizeMessageType from 'lib/normalizeMessageType';

export const setPipelineAndLeadStatusOnCreation = ({ event }) => {
  if (!(event || {}).event_id) {
    return;
  }
  const uniqueId = (event || {}).unique_id ? event.unique_id : `${event.event_id}_${normalizeMessageType((event || {}).event_type)}`;
  const payload = {
    is_read: '1',
    event_type: (event || {}).event_type,
  };
  const data = {
    event: 'count',
    key: `updateReadUnreadStateConversations`,
    message: {
      count: {
        currentFolder: (event || {}).status_id,
        is_read: payload.is_read,
      },
    },
  };
  putMessageStatus(event.event_id, payload, () => {
    if (uniqueId) {
      action('PATCH_MESSAGE_AS_READ', uniqueId);
    }
    publishAction({ data });
  });
};
